












import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import PannelloCensimenti from './PannelloCensimenti.vue'
import PannelloManutenzioni from './PannelloManutenzioni.vue'
import { TIPO_DATI_CENSIMENTI, TIPO_DATI_MANUTENZIONI } from '../../costanti'

export default Vue.extend({
    components: {
        PannelloCensimenti,
        PannelloManutenzioni
    },
    data: () => ({
        TIPO_DATI_CENSIMENTI,
        TIPO_DATI_MANUTENZIONI,
        panelloSelezionato: TIPO_DATI_CENSIMENTI
    }),
    computed: {
        ...mapState('mapplantsMappa', ['tipoDatiMostrati']),
        ...mapState('mapplantsMappa', ['statoRilevamenti'])
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapMutations('mapplantsMappa', ['SET_TIPO_DATI_MOSTRATI'])
    }
})
